import {
  ARTIFACT_TYPE_EXTENSIONS,
  type ArtifactType,
} from "../types/artifact";

/** Build a `File` for upload/download using the artifact’s native type only (no conversion). */
export function createOriginalFormatFile(
  content: string,
  title: string,
  type: string,
): File {
  const base = (title || "artifact").trim() || "artifact";
  const artifactType = type as ArtifactType;
  const ext = ARTIFACT_TYPE_EXTENSIONS[artifactType] ?? ".txt";
  const filename = `${base}${ext}`;

  const mime =
    artifactType === "text/html"
      ? "text/html"
      : artifactType === "text/markdown"
        ? "text/markdown"
        : artifactType === "image/svg+xml"
          ? "image/svg+xml"
          : "text/plain";

  return new File([content], filename, { type: mime });
}
